<template>
  <div class="about">
    <my-navi activeIndex="18"></my-navi>
    <el-container>
      <el-header>
        <span style="font-weight: bold; font-size: 16px;">US2CA/AU 库存价格同步工具</span>
      </el-header>
      <el-main>
        <el-card>
          <el-descriptions :column="1" border>
            <el-descriptions-item label="操作步骤">
              <ol>
                <li><strong>第一步：上传报告</strong> — 分别上传US库存报告和CA/AU库存报告，选择目标站点（加拿大或澳大利亚）。</li>
                <li><strong>第二步：筛选确认</strong> — 查看规则1（下架检测）的结果，点击"删除"剔除不需要下架的商品，然后点击"下架"按钮将确认下架的条目加入导出结果。规则2（价格同步）的结果会自动进入导出列表。</li>
                <li><strong>第三步：下载文件</strong> — 下载"结果文件"上传到亚马逊进行批量操作，同时下载"预期库存报告"保存，用于后续验证。</li>
                <li><strong>第四步：验证结果</strong> — 等待亚马逊处理完成（通常需要2小时以上），下载最新库存报告，在下方"库存报告对比工具"中与预期报告进行对比，确认改价和下架是否成功。</li>
              </ol>
            </el-descriptions-item>
            <el-descriptions-item label="文件格式">
              每行包含 seller-sku、asin、price、quantity 四部分信息，用空格分隔。
            </el-descriptions-item>
            <el-descriptions-item label="导出结果说明">
              <ul>
                <li><strong>规则1（下架检测）：</strong>自动识别US站点已下架或删除但CA/AU站点仍在售的商品。执行对比后，规则1结果不会自动进入导出列表，需用户筛选后点击"下架"按钮加入。</li>
                <li><strong>规则2（价格同步）：</strong>基于US站点价格，自动计算CA/AU站点的同步价格（含运费和汇率），确保跨站点价格一致性，对比后自动进入导出列表。</li>
                <li><strong>结果整合：</strong>规则1（点击下架后）和规则2的商品会合并到最终导出的调价模板中，方便批量操作。</li>
                <li><strong>预期库存报告：</strong>可基于导出结果生成预期库存报告（格式与原始库存报告一致），用于后续与实际库存对比。</li>
              </ul>
            </el-descriptions-item>
            <el-descriptions-item label="参数配置">
              <ul>
                <li>CA运费: $10, 汇率: 1.42</li>
                <li>AU运费: $150, 汇率: 1.44</li>
                <li>minimum-seller-allowed-price = price * 2/3</li>
                <li>maximum-seller-allowed-price = price * 1.5</li>
              </ul>
            </el-descriptions-item>
          </el-descriptions>
          <el-row style="margin-top: 20px;">
            <el-col :span="8">
              <el-upload
                :on-change="loadUSFile"
                :before-upload="checkTxtFile"
                :show-file-list="false"
                accept=".txt"
              >
                <el-button slot="trigger" type="primary">
                  <i class="el-icon-upload"></i>
                  上传US库存报告
                </el-button>
              </el-upload>
              <span v-if="usFileName" style="margin-left: 10px; color: #67c23a;">{{ usFileName }}</span>
            </el-col>
            <el-col :span="8">
              <el-upload
                :on-change="loadTargetFile"
                :before-upload="checkTxtFile"
                :show-file-list="false"
                accept=".txt"
              >
                <el-button slot="trigger" type="primary">
                  <i class="el-icon-upload"></i>
                  上传CA/AU库存报告
                </el-button>
              </el-upload>
              <span v-if="targetFileName" style="margin-left: 10px; color: #67c23a;">{{ targetFileName }}</span>
            </el-col>
            <el-col :span="8">
              <el-select placeholder="选择目标站点" v-model="targetSite" style="width: 200px;">
                <el-option label="加拿大 (CA)" value="CA"></el-option>
                <el-option label="澳大利亚 (AU)" value="AU"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-col :span="6">
              <el-input-number v-model="shippingFee" :min="0" :max="1000" :step="1" placeholder="运费" />
            </el-col>
            <el-col :span="6">
              <el-input-number v-model="exchangeRate" :min="0.01" :max="10" :step="0.01" placeholder="汇率" />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="compareInventory" :disabled="!usData.length || !targetData.length || !targetSite">
                <i class="el-icon-refresh"></i>
                执行对比
              </el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="success" @click="downloadResult" :disabled="!resultData.length">
                <i class="el-icon-download"></i>
                下载结果文件
              </el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="info" @click="downloadExpectedInventory" :disabled="!resultData.length">
                <i class="el-icon-download"></i>
                下载预期库存报告
              </el-button>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-col :span="12">
              <el-card>
                <div slot="header">
                  <span>规则1结果 (US库存为0或不存在，CA/AU有库存)</span>
                  <span style="float: right; color: #909399;">共 {{ rule1Data.length }} 条</span>
                </div>
                <el-table :data="rule1Data" style="font-size: 12px;">
                  <el-table-column label="SKU" prop="sku" width="250px" />
                  <el-table-column label="Price" prop="price" width="80px" />
                  <el-table-column label="Min Price" prop="minPrice" width="100px" />
                  <el-table-column label="Max Price" prop="maxPrice" width="100px" />
                  <el-table-column label="CA/AU库存" prop="caAuQuantity" width="80px" />
                  <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeRule1Row(scope.$index)">删除</el-button>
                      <el-button size="mini" type="warning" icon="el-icon-minus" @click="addToResult(scope.$index)" style="margin-left: 5px;">下架</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin-top: 10px; text-align: right;">
                  <el-button type="danger" @click="batchAddToResult" :disabled="!rule1Data.length">
                    
                    将剩余全部加入下架列表
                  </el-button>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card>
                <div slot="header">
                  <span>规则2结果 (SKU相同，同步价格)</span>
                  <span style="float: right; color: #909399;">共 {{ rule2Data.length }} 条</span>
                </div>
                <el-table :data="rule2Data" style="font-size: 12px;">
                  <el-table-column label="SKU" prop="sku" width="250px" />
                  <el-table-column label="US Price" prop="usPrice" width="100px" />
                  <el-table-column label="Target Price" prop="price" width="100px" />
                  <el-table-column label="Min Price" prop="minPrice" width="120px" />
                  <el-table-column label="Max Price" prop="maxPrice" width="120px" />
                  <el-table-column label="Quantity" prop="quantity" width="80px" />
                </el-table>
              </el-card>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-card>
              <div slot="header">
                <span>合并结果预览 (库存调整格式)</span>
                <span style="float: right; color: #909399;">共 {{ resultData.length }} 条</span>
              </div>
              <el-table :data="resultData" style="font-size: 12px;">
                <el-table-column label="sku" prop="sku" width="300px" />
                <el-table-column label="price" prop="price" width="100px" />
                <el-table-column label="minimum-seller-allowed-price" prop="minPrice" width="180px" />
                <el-table-column label="maximum-seller-allowed-price" prop="maxPrice" width="180px" />
                <el-table-column label="quantity" prop="quantity" width="80px" />
                <el-table-column label="handling-time" prop="handlingTime" width="120px" />
                <el-table-column label="fulfillment-channel" prop="fulfillmentChannel" width="150px" />
              </el-table>
            </el-card>
          </el-row>
        </el-card>
        <el-card style="margin-top: 20px;">
          <div slot="header">
            <span style="font-weight: bold;">库存报告对比工具</span>
          </div>
          <el-descriptions :column="1" border>
            <el-descriptions-item label="功能说明">
              上传预期库存报告和实际库存报告，对比找出差异记录，用于验证调价操作是否生效。
            </el-descriptions-item>
          </el-descriptions>
          <el-row style="margin-top: 20px;">
            <el-col :span="8">
              <el-upload
                :on-change="loadExpectedFile"
                :before-upload="checkTxtFile"
                :show-file-list="false"
                accept=".txt"
              >
                <el-button slot="trigger" type="warning">
                  <i class="el-icon-upload"></i>
                  上传预期库存报告
                </el-button>
              </el-upload>
              <span v-if="expectedFileName" style="margin-left: 10px; color: #67c23a;">{{ expectedFileName }}</span>
            </el-col>
            <el-col :span="8">
              <el-upload
                :on-change="loadActualFile"
                :before-upload="checkTxtFile"
                :show-file-list="false"
                accept=".txt"
              >
                <el-button slot="trigger" type="warning">
                  <i class="el-icon-upload"></i>
                  上传实际库存报告
                </el-button>
              </el-upload>
              <span v-if="actualFileName" style="margin-left: 10px; color: #67c23a;">{{ actualFileName }}</span>
            </el-col>
            <el-col :span="8">
              <el-button type="primary" @click="compareInventoryReports" :disabled="!expectedData.length || !actualData.length">
                <i class="el-icon-refresh"></i>
                执行对比
              </el-button>
              <el-button type="success" @click="downloadDiffResult" :disabled="!diffData.length" style="margin-left: 10px;">
                <i class="el-icon-download"></i>
                下载差异结果
              </el-button>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-card>
              <div slot="header">
                <span>对比差异结果</span>
                <span style="float: right; color: #909399;">共 {{ diffData.length }} 条</span>
              </div>
              <el-table :data="diffData" style="font-size: 12px;">
                <el-table-column label="SKU" prop="sku" width="250px" />
                <el-table-column label="差异类型" prop="diffType" width="120px">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.diffType === 'missing' ? 'danger' : 'warning'">
                      {{ scope.row.diffType === 'missing' ? '预期有实际无' : '数据不一致' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="预期价格" prop="expectedPrice" width="100px" />
                <el-table-column label="实际价格" prop="actualPrice" width="100px" />
                <el-table-column label="预期库存" prop="expectedQuantity" width="100px" />
                <el-table-column label="实际库存" prop="actualQuantity" width="100px" />
                <el-table-column label="差异说明" prop="diffDesc" width="200px" />
              </el-table>
            </el-card>
          </el-row>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      targetSite: "",
      shippingFee: 10,
      exchangeRate: 1.42,
      usData: [],
      targetData: [],
      usFileName: "",
      targetFileName: "",
      rule1Data: [],
      rule2Data: [],
      resultData: [],
      // 库存报告对比相关
      expectedData: [],
      actualData: [],
      expectedFileName: "",
      actualFileName: "",
      diffData: [],
      // 默认配置
      defaultConfigs: {
        CA: { shippingFee: 10, exchangeRate: 1.42 },
        AU: { shippingFee: 150, exchangeRate: 1.44 }
      }
    };
  },
  watch: {
    targetSite(newVal) {
      if (newVal && this.defaultConfigs[newVal]) {
        this.shippingFee = this.defaultConfigs[newVal].shippingFee;
        this.exchangeRate = this.defaultConfigs[newVal].exchangeRate;
      }
    }
  },
  mounted() {},
  methods: {
    checkTxtFile(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "txt") {
        this.$message.error("只能上传txt文本文件");
        return false;
      }
      return false;
    },
    loadUSFile(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "txt") {
        this.$message.error("只能上传txt文本文件");
        return;
      }
      this.usFileName = file.raw.name;
      this.readTxtFile(file.raw, data => {
        this.usData = data;
        this.$message.success(`US库存报告加载成功，共 ${data.length} 条记录`);
      });
    },
    loadTargetFile(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "txt") {
        this.$message.error("只能上传txt文本文件");
        return;
      }
      this.targetFileName = file.raw.name;
      this.readTxtFile(file.raw, data => {
        this.targetData = data;
        this.$message.success(`CA/AU库存报告加载成功，共 ${data.length} 条记录`);
      });
    },
    readTxtFile(file, callback) {
      const reader = new FileReader();
      reader.onload = e => {
        const content = e.target.result;
        const data = this.parseTxtContent(content);
        callback(data);
      };
      reader.onerror = () => {
        this.$message.error("文件读取失败，请重试");
      };
      reader.readAsText(file, "UTF-8");
    },
    parseTxtContent(content) {
      const lines = content.split(/\r?\n/);
      const result = [];
      // 跳过表头行
      let skipFirst = true;
      for (let line of lines) {
        line = line.trim();
        if (!line) continue;
        if (skipFirst && line.toLowerCase().includes("seller-sku")) {
          skipFirst = false;
          continue;
        }
        // 使用正则匹配四部分：seller-sku(可能含连字符)、asin(字母数字)、price(数字)、quantity(数字)
        // seller-sku可能包含特殊字符，直到遇到连续空格分隔
        const parts = line.match(/^([^\s]+)\s+([^\s]+)\s+([\d.]+)\s+(\d+)$/);
        if (parts && parts.length === 5) {
          result.push({
            sku: parts[1],
            asin: parts[2],
            price: parseFloat(parts[3]),
            quantity: parseInt(parts[4])
          });
        } else {
          // 尝试另一种解析方式：按空格分割，取前四个部分
          const splitParts = line.split(/\s+/);
          if (splitParts.length >= 4) {
            result.push({
              sku: splitParts[0],
              asin: splitParts[1],
              price: parseFloat(splitParts[2]),
              quantity: parseInt(splitParts[3])
            });
          }
        }
      }
      return result;
    },
    compareInventory() {
      if (!this.usData.length || !this.targetData.length) {
        this.$message.warning("请先上传两份库存报告");
        return;
      }
      if (!this.targetSite) {
        this.$message.warning("请选择目标站点");
        return;
      }
      // 构建US数据的SKU索引
      const usMap = {};
      for (let item of this.usData) {
        usMap[item.sku] = item;
      }
      // 构建目标数据的SKU索引
      const targetMap = {};
      for (let item of this.targetData) {
        targetMap[item.sku] = item;
      }
      this.rule1Data = [];
      this.rule2Data = [];
      this.resultData = [];
      // 遍历目标数据，查找匹配的SKU
      for (let sku in targetMap) {
        const usItem = usMap[sku];
        const targetItem = targetMap[sku];
        // 规则1：US库存为0或不存在，但CA/AU有库存
        if (targetItem.quantity > 0 && (!usItem || usItem.quantity === 0)) {
          let calcPrice, minPrice, maxPrice;
          if (usItem) {
            // US存在，按公式计算
            calcPrice = Math.ceil(this.calculatePrice(usItem.price));
            minPrice = (calcPrice * 2 / 3).toFixed(2);
            maxPrice = (calcPrice * 1.5).toFixed(2);
          } else {
            // US不存在，使用CA/AU价格
            calcPrice = Math.ceil(targetItem.price);
            minPrice = (calcPrice * 2 / 3).toFixed(2);
            maxPrice = (calcPrice * 1.5).toFixed(2);
          }
          const record = {
            sku: sku,
            asin: targetItem.asin,
            price: calcPrice.toString(),
            minPrice: minPrice,
            maxPrice: maxPrice,
            quantity: 0,
            caAuQuantity: targetItem.quantity,
            handlingTime: "1",
            fulfillmentChannel: "DEFAULT"
          };
          this.rule1Data.push(record);
        }
        if (!usItem) continue;
        // 计算价格，向上取整
        const calcPrice = Math.ceil(this.calculatePrice(usItem.price));
        const minPrice = (calcPrice * 2 / 3).toFixed(2);
        const maxPrice = (calcPrice * 1.5).toFixed(2);
        // 规则2：SKU相同的记录
        const rule2Record = {
          sku: sku,
          asin: targetItem.asin,
          usPrice: usItem.price,
          price: calcPrice.toString(),
          minPrice: minPrice,
          maxPrice: maxPrice,
          quantity: targetItem.quantity,
          handlingTime: "1",
          fulfillmentChannel: "DEFAULT"
        };
        this.rule2Data.push(rule2Record);
        // 规则2的记录始终添加到结果
        this.resultData.push(rule2Record);
      }
      this.$message.success(`对比完成！规则1: ${this.rule1Data.length} 条，规则2: ${this.rule2Data.length} 条`);
    },
    calculatePrice(usPrice) {
      return (usPrice + this.shippingFee) * this.exchangeRate;
    },
    removeRule1Row(index) {
      const item = this.rule1Data[index];
      if (item) {
        this.rule1Data.splice(index, 1);
      }
    },
    addToResult(index) {
      const item = this.rule1Data[index];
      if (item) {
        // 将记录添加到导出结果
        this.resultData.push(item);
        // 从规则1列表中移除（已确认下架）
        this.rule1Data.splice(index, 1);
        this.$message.success(`SKU ${item.sku} 已加入下架列表`);
      }
    },
    batchAddToResult() {
      if (!this.rule1Data.length) return;
      // 将所有剩余记录添加到导出结果
      for (let item of this.rule1Data) {
        this.resultData.push(item);
      }
      const count = this.rule1Data.length;
      this.rule1Data = [];
      this.$message.success(`已将 ${count} 条记录加入下架列表`);
    },
    downloadResult() {
      if (!this.resultData.length) return;
      // 生成图3格式的文本文件，handling-time和fulfillment-channel留空
      let content = "sku\tprice\tminimum-seller-allowed-price\tmaximum-seller-allowed-price\tquantity\thandling-time\tfulfillment-channel\n";
      for (let item of this.resultData) {
        content += `${item.sku}\t${item.price}\t${item.minPrice}\t${item.maxPrice}\t${item.quantity}\t\t\n`;
      }
      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `inventory_adjustment_${this.targetSite}_${new Date().toISOString().split("T")[0]}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    downloadExpectedInventory() {
      if (!this.resultData.length) return;
      // 生成预期库存报告，格式与原始库存报告一致：seller-sku asin price quantity
      let content = "seller-sku\tasin\tprice\tquantity\n";
      for (let item of this.resultData) {
        content += `${item.sku}\t${item.asin || ""}\t${item.price}\t${item.quantity}\n`;
      }
      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `expected_inventory_${this.targetSite}_${new Date().toISOString().split("T")[0]}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    // 库存报告对比相关方法
    loadExpectedFile(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "txt") {
        this.$message.error("只能上传txt文本文件");
        return;
      }
      this.expectedFileName = file.raw.name;
      this.readTxtFile(file.raw, data => {
        this.expectedData = data;
        this.$message.success(`预期库存报告加载成功，共 ${data.length} 条记录`);
      });
    },
    loadActualFile(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "txt") {
        this.$message.error("只能上传txt文本文件");
        return;
      }
      this.actualFileName = file.raw.name;
      this.readTxtFile(file.raw, data => {
        this.actualData = data;
        this.$message.success(`实际库存报告加载成功，共 ${data.length} 条记录`);
      });
    },
    compareInventoryReports() {
      if (!this.expectedData.length || !this.actualData.length) {
        this.$message.warning("请先上传预期库存报告和实际库存报告");
        return;
      }
      // 构建实际数据的SKU索引
      const actualMap = {};
      for (let item of this.actualData) {
        actualMap[item.sku] = item;
      }
      this.diffData = [];
      // 遍历预期数据，找出差异
      for (let expectedItem of this.expectedData) {
        const actualItem = actualMap[expectedItem.sku];
        if (!actualItem) {
          // 预期有，实际无
          this.diffData.push({
            sku: expectedItem.sku,
            diffType: "missing",
            expectedPrice: expectedItem.price,
            actualPrice: "-",
            expectedQuantity: expectedItem.quantity,
            actualQuantity: "-",
            diffDesc: "商品在实际库存中不存在"
          });
        } else {
          // 对比价格和库存
          const diffs = [];
          if (expectedItem.price !== actualItem.price) {
            diffs.push(`价格不一致 (预期: ${expectedItem.price}, 实际: ${actualItem.price})`);
          }
          if (expectedItem.quantity !== actualItem.quantity) {
            diffs.push(`库存不一致 (预期: ${expectedItem.quantity}, 实际: ${actualItem.quantity})`);
          }
          if (diffs.length > 0) {
            this.diffData.push({
              sku: expectedItem.sku,
              diffType: "mismatch",
              expectedPrice: expectedItem.price,
              actualPrice: actualItem.price,
              expectedQuantity: expectedItem.quantity,
              actualQuantity: actualItem.quantity,
              diffDesc: diffs.join("; ")
            });
          }
        }
      }
      this.$message.success(`对比完成！共发现 ${this.diffData.length} 条差异记录`);
    },
    downloadDiffResult() {
      if (!this.diffData.length) return;
      let content = "sku\t差异类型\t预期价格\t实际价格\t预期库存\t实际库存\t差异说明\n";
      for (let item of this.diffData) {
        const typeName = item.diffType === "missing" ? "预期有实际无" : "数据不一致";
        content += `${item.sku}\t${typeName}\t${item.expectedPrice}\t${item.actualPrice}\t${item.expectedQuantity}\t${item.actualQuantity}\t${item.diffDesc}\n`;
      }
      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `inventory_diff_${new Date().toISOString().split("T")[0]}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style>
.el-table th, .el-table td {
  padding: 6px 8px;
}
</style>
